export const slideoverFieldsetClassName =
  "my-4 grid grid-cols-1 sm:grid-cols-2 gap-4 p-6 relative items-stretch";
